<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  @if (!resultReceived) {
    <div class="flex-col justify-center items-center w-100 my-3 ">
      <span>I want to buy this property for</span>
      <span class="amount">{{buyNowAmount | currency : 'USD' : 'symbol' : '1.2'}}</span>
    </div>
  }
  @else {
    <div class="flex-col justify-center items-center w-100 my-3">
      <span class="amount">{{buyNowAmount | currency : 'USD' : 'symbol' : '1.2'}}</span>
      <span>{{resultText}}</span>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions >
  <div class="flex-row spce-between items-center w-100 mt-3 p-2">
    <button [disabled]="!canSubmit" mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    <button [disabled]="!canCancel" [ngClass]="resultReceived?'w-100':'w-50'" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

